<template>
  <div class="inline-block">
    <!-- 转化事件 -->
    <div v-if="formKey === 'convert_id'">
      <div class="flex items-center">
        <div v-show="!formItem.isPreview" class="mr-10">
          <el-button type="primary" size="mini" @click="onDataDialog('budget_and_bid_form', 'convert_id', '转化事件目标')">选择转化目标</el-button>
        </div>
      </div>
    </div>
    <!-- 数据弹窗 -->
    <el-dialog
      v-if="data_dialog_config.is_show"
      :title="data_dialog_config.title"
      :visible.sync="data_dialog_config.is_show"
      append-to-body
    >
      <component
        :is="data_dialog_config.map_component_name[data_dialog_config.active_name]"
        v-if="data_dialog_config.is_show"
        v-loading="data_dialog_config.is_loading"
        v-bind="data_dialog_config.getters.getProps(data_dialog_config.active_name)"
        @confirm="onDataDialogConfirm"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getDeepConvertGoalApi } from '@/api/tool/deep-convert-goal';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { transformTreeKey } from '@/tools/form';
import { getConvertApi } from '@/api/tool/convert';
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'conversion-event': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/budget-and-bid-form/components/conversion/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  data() {
    return {
      // 数据弹窗配置
      data_dialog_config: {
        is_show: false,
        title: '',
        is_loading: false,
        active_name: '',
        map_component_name: {
          convert_id: 'conversion-event',
        },
        getters: {
          getProps: (active_name) => {
            const map_props = {
              convert_id: {
                tableParams: this.getConvertFiltering(),
                getList: this.getConvertList,
              },
            };
            return Object.assign(map_props[active_name] || {});
          },
        },
      },
    };
  },
  methods: {
    /**
     * 打开数据弹窗
     * @param {string} field_key 表单配置项
     * @param {string} active_name 表单项
     * @param {string} title 弹窗标题
     */
    onDataDialog(field_key, active_name, title) {
      Object.assign(this.data_dialog_config, {
        is_show: true,
        is_loading: false,
        title,
        active_name,
        field_key,
      });
    },
    /**
     * 获取转化目标查询参数
     */
    getConvertFiltering() {
      const { delivery_form } = this.formFields.config;
      const { delivery_content_id, delivery_platform_type } = delivery_form.config;
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      const channel_interface = dataController.getChannelInterfaceEnum();
      const advertiser_id = dataController.getRequestAdvertiser();
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          return {
            filtering: {
              ...(Object.keys(delivery_content_id.value.result_map).length && { delivery_content_id: delivery_content_id.value.result_map[advertiser_id].value.split('#')[0] }),
              delivery_platform_type: delivery_platform_type.value,
            },
          };
        },
        default: () => {
          return {
            filtering: {
              ...(delivery_content_id.value && { delivery_content_id: delivery_content_id.value.split('#')[0] }),
              delivery_platform_type: delivery_platform_type.value,
            },
          };
        },
      };
      return {
        channel_interface,
        advertiser_id,
        page: 1,
        page_size: 10,
        ...(strategy[channel_interface] || strategy['default'])(),
      };
    },
    /**
     * 获取转化目标
     * @param {Object} params 查询参数
     */
    getConvertList(params) {
      return new Promise((resolve, reject) => {
        getConvertApi(params)
          .then((res) => {
            res.list.forEach((item) => {
              Object.assign(item, { template_data: JSON.stringify(item) });
            });
            resolve(res);
          })
          .catch(reject);
      });
    },
    /**
     * 获取深度转化目标查询参数
     */
    getDeepConvertGoalFiltering() {
      const { budget_and_bid_form, site_form } = this.formFields.config;
      const { convert_id } = budget_and_bid_form.config;
      const { site_sets } = site_form.config;
      const extra_params = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: {
          huawei_params: {
            filtering: {
              convert_id: JSON.parse(convert_id.value)?.id,
              site_set_id: site_sets.value[0],
            },
          },
        },
      };
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      const channel_interface = dataController.getChannelInterfaceEnum();
      const advertiser_id = dataController.getRequestAdvertiser();
      return {
        channel_interface,
        advertiser_id,
        ...extra_params[channel_interface],
      };
    },
    /**
     * 获取深度转化目标
     */
    async getDeepConvertGoal() {
      try {
        this.data_dialog_config.is_loading = true;
        const res = await getDeepConvertGoalApi(this.getDeepConvertGoalFiltering());
        const list = transformTreeKey({ options: res.list, label_key: 'name', value_key: 'id' });
        return Promise.resolve(list);
      } catch (error) {
        return Promise.reject(new Error(error));
      } finally {
        this.data_dialog_config.is_loading = false;
      }
    },
    /**
     * 数据模块确认回调
     * @param {Object} payload 确认数据
     */
    async onDataDialogConfirm(payload) {
      const { template_data } = payload;
      const { field_key, active_name } = this.data_dialog_config;
      const { config } = this.formFields.config[field_key];
      config[active_name].value = template_data;
      const handlers_map = {
        // 转化事件
        convert_id: async() => {
          const { convert_goal } = payload;
          const fusion__optimize_goal = config.fusion__optimize_goal;
          const deep_convert_type = config.deep_convert_type;
          const { channel_interface } = this.initOps;
          const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;
          fusion__optimize_goal.value = convert_goal_enum_val[convert_goal];
          fusion__optimize_goal.hidden = !convert_goal;
          // 获取深度优化目标
          const deep_convert_data = await this.getDeepConvertGoal();
          deep_convert_type.options = deep_convert_data;
          deep_convert_type.value = deep_convert_data[0]?.value;
          deep_convert_type.hidden = !deep_convert_data.length;
          /**
           * 深度优化出价
           * 满足以下条件才会显示
           * - 深度优化目标有数据项
           * - 深度优化目标类型存在值且不为0
           */
          config.deep_convert_price.hidden = !(deep_convert_data.length && deep_convert_type.value && deep_convert_type.value !== 0);
          this.$parent.$parent.$parent.validateField('convert_id.value');
        },
      };
      await handlers_map[active_name]?.();
      Object.assign(this.data_dialog_config, { is_show: false, is_loading: false, title: '', active_name: '', field_key: '' });
    },
  },
};
</script>
